import type { StylesConfig } from 'react-select';

export function buildReportSelectStyles<Option = { value: any; label: string }, IsMulti extends boolean = boolean>(
  isDark: boolean,
): StylesConfig<Option, IsMulti>
{
  return {
    control: base => ({
      ...base,
      minHeight: 30,
      fontSize: 11,
      borderColor: isDark ? '#4a4c4c' : '#ccc',
      boxShadow: 'none',
      borderRadius: 4,
      backgroundColor: isDark ? '#3a3c3c' : '#fff',
      '&:hover': { borderColor: isDark ? '#6e6860' : '#aaa' },
    }),
    menu: base => ({
      ...base,
      fontSize: 11,
      zIndex: 9999,
      borderRadius: 2,
      marginTop: 2,
      backgroundColor: isDark ? '#3a3c3c' : '#fff',
      border: isDark ? '1px solid #4a4c4c' : undefined,
    }),
    menuList: base => ({ ...base, padding: 0 }),
    valueContainer: base => ({
      ...base,
      padding: '2px 6px',
      gap: 2,
      maxHeight: 120,
      overflowY: 'auto',
    }),
    indicatorsContainer: base => ({ ...base, height: 25 }),
    indicatorSeparator: () => ({ display: 'none' }),
    clearIndicator: base => ({
      ...base,
      padding: '0 2px',
      color: isDark ? '#6e6860' : '#999',
      cursor: 'pointer',
      '& svg': { width: 14, height: 14 },
    }),
    dropdownIndicator: () => ({ display: 'none' }),
    singleValue: base => ({ ...base, color: isDark ? '#a9a093' : '#333' }),
    input: base => ({ ...base, color: isDark ? '#a9a093' : '#333' }),
    placeholder: base => ({ ...base, color: isDark ? '#6e6860' : base.color }),
    multiValue: base => ({
      ...base,
      backgroundColor: isDark ? '#4a4c4c' : '#fff',
      border: `1px solid ${isDark ? '#6e6860' : '#ccc'}`,
      borderRadius: 3,
      margin: '1px 2px',
    }),
    multiValueLabel: base => ({
      ...base,
      fontSize: 11,
      color: isDark ? '#a9a093' : '#333',
      padding: '1px 4px',
    }),
    multiValueRemove: base => ({
      ...base,
      color: isDark ? '#a9a093' : '#888',
      padding: '0 3px',
      ':hover': {
        backgroundColor: isDark ? '#6e6860' : '#e8e8e8',
        color: isDark ? '#fff' : '#555',
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor:
        state.isSelected || state.isFocused ? '#62accb' : isDark ? '#3a3c3c' : 'transparent',
      color: state.isSelected || state.isFocused ? '#fff' : isDark ? '#a9a093' : '#333',
      fontSize: 11,
      padding: '5px 10px',
      cursor: 'pointer',
      ':active': { backgroundColor: '#508ca6', color: '#fff' },
    }),
  } as StylesConfig<Option, IsMulti>;
}
